import React from 'react';
import ReactDOM from 'react-dom';
import { Loader2 } from 'lucide-react';

interface LoadingOverlayProps {
  message: string;
  progress?: number;
}

export function LoadingOverlay({ message, progress }: LoadingOverlayProps) {
  // Use portal to render at document root level
  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-background/50 backdrop-blur-sm z-[9999] flex items-center justify-center">
      <div className="bg-card rounded-lg border shadow-lg p-6 min-w-[300px] max-w-md mx-4">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-base text-center">
            {message}
          </p>
          {typeof progress === 'number' && (
            <div className="w-full space-y-2">
              <div className="w-full bg-secondary rounded-full h-2 overflow-hidden">
                <div 
                  className="bg-primary h-full rounded-full transition-all duration-300 ease-out"
                  style={{ width: `${progress}%` }}
                />
              </div>
              <p className="text-sm text-muted-foreground text-center">
                {Math.round(progress)}%
              </p>
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
} 